import React, { useState, useRef, useEffect } from "react";
// import arrowicon from "../../Assets/Images/arrowicon.png";
// import attach from "../../Assets/Images/attach.png";
import { InputText } from "primereact/inputtext";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import { Menu, Dropdown, Button, Typography, Space } from "antd";
import TranslateIcon from "@mui/icons-material/Translate";
import { Card } from "primereact/card";
import { Modal, Drawer, message } from "antd";
import VolumeUpIcon from "@mui/icons-material/VolumeUp";
import PauseIcon from "@mui/icons-material/Pause";
import './newcaresathi.css';
import { useNavigate, useLocation } from "react-router-dom";
import AttachFileIcon from '../../assets/uploadicon.svg';
import Caresathi from '../../assets/curebaylogo.svg';
// import Send from '../../assets/send_icon.svg';

import moment from "moment";
import {
  MenuOutlined,
  UploadOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import { Segmented } from "antd";
import MicRecorder from './MicRecorder';
import { Send } from "lucide-react";
import OurLayouts from "../layout";
import ChatLoading from "./ChatLoading";

const { Title, Text } = Typography;

const Newcaresathi = () => {
  const [messageApi, contextHolder] = message.useMessage();
  const [getAnswerBot, setgetAnswerBot] = useState([]);
  const [sampleMessage, setSampleMessage] = useState("");
  const [question, setQuestion] = useState("");
  let s_token = localStorage.getItem("auth_token");
  const [formDataState, setFormDataState] = useState(null);
  const [qaHistory, setQaHistory] = useState([]);
  const [flagselectedagent, setFlagselectedagent] = useState(false);

  const [serviceRecommendationObject, setServiceRecommendationObject] =
    useState({
      ["-1"]: [
        {
          link: "",
          reasoning: "",
          service: "",
        },
      ],
    });
  const fileInputRef = useRef(null);
  const [extractedData, setExtractedData] = useState("");
  const [uploadedFileName, setUploadedFileName] = useState("");
  const chatContainerRef = useRef(null);
  const activePatient = JSON.parse(localStorage.getItem("activePatient"));
  const [openSnackbar, setOpenSnackbar] = useState(false);
  var circleCode = localStorage.getItem("userId");
  const [base64pdf, setBase64pdf] = useState("");
  const [snackbarmsg, setSnackbarmsg] = useState({ msg: "", type: "" });
  const [showaddmemberpopup, setshowaddmemberpopup] = useState(false);
  const [documanttype, setDocumanttype] = useState("");
  const [chatHistory, setChatHistory] = useState({});
  const [chatHistoryDrawer, setChatHistoryDrawer] = useState(false);
  const [screenHeight, setScreenHeight] = useState(window.innerHeight);
  const [timeStamp, setTimestamp] = useState("");
  const [textAnimationFinish, setTextAnimationFinish] = useState(false);
  const [answerCount, setAnswerCount] = useState(-1);
  const [languageModalVisible, setLanguageModalVisible] = useState(true);
  const [isSpeaking, setIsSpeaking] = useState(false);
  const [audioInstances, setAudioInstances] = useState({});
  const [playingAudioId, setPlayingAudioId] = useState(null);
  const [openLabReportAnalyserModal, setopenLabReportAnalyserModal] =
    useState(false);
  const navigate = useNavigate();
  const location = useLocation(); // Get the location object from the router
  const queryParams = new URLSearchParams(location.search); // Create a URLSearchParams object with the query string
  const [selectedLanguage, setSelectedLanguage] = React.useState("en");
  const [alignValue, setAlignValue] = React.useState("center");
  // Extracting individual query parameters
  const lab_report_analyser = queryParams.get("lab_report_analyser");
  const lab_report_analyser_popup = queryParams.get("popup");
  const reportUrl = queryParams.get("reportUrl");
  const reportExtType = queryParams.get("reportExtType");
  const orderId = queryParams.get("orderId");
  const [labreportanalyseflag, setlabreportanalyse] = useState(false);
  const [translatedAnswer, setTranslatedAnswer] = useState({});
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState("");
  const [loading, setLoading] = useState(false);
  const [newchartflag, setNewchartflag] = useState(false);
  const messagesEndRef = useRef(null);
  const [chartEnded, setchartEnded] = useState(false);
  const [disabledTranslations, setDisabledTranslations] = useState(new Set());

  const [useDigitalPrescription, setUseDigitalPrescription] = useState(false);

  const genrateRandomTimestamp = () => {
    const timeWithSeconds = moment().format('YYYYMMDDHHmmss'); // e.g., 20250407155330
    const randomNum = Math.floor(Math.random() * 1000); // e.g., 457
    return `${timeWithSeconds}${randomNum}`;
  };

  const [sessionId, setSessionId] = useState(() => genrateRandomTimestamp());

  const [convertedText, setConvertedText] = useState({
    index: -1,
    type: "",
    text: "",
  });

  const scrollToBottom = () => {
    if (chatContainerRef.current) {
      const container = chatContainerRef.current;
      requestAnimationFrame(() => {
        container.scroll({
          top: container.scrollHeight,
          behavior: "smooth",
        });
      });
    }
  };

  useEffect(() => {
    if (qaHistory.length) {
      scrollToBottom();
    }
  }, [qaHistory]);

  useEffect(() => {
    // Initially hide the iframe with id="launcher-frame"
    const iframe = document.getElementById("freshworks-container");
    if (iframe) {
      iframe.style.display = "none";
    }
  }, [])

  useEffect(() => {
    const handleResize = () => setScreenHeight(window.innerHeight);
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);






  useEffect(() => {
    if (qaHistory.length) {
      scrollToBottom();  // Scroll to bottom when chat history updates
    }
  }, [qaHistory]);

  useEffect(() => {
    if (qaHistory.length) {
      scrollToBottom(); // Scrolls to the bottom when chat history is updated
    }
  }, [qaHistory]);

  useEffect(() => {
    if (loading === false && !showHeader) {
      scrollToBottom(); // Scrolls when loading is done or after a new message is added
    }
  }, [loading]);

  useEffect(() => {
    setshowaddmemberpopup(true);
  }, []);

  useEffect(() => {
    setSessionId(genrateRandomTimestamp());
  }, []);



  const getChatHistory = () => {
    let payload = {
      identifier: "CLINIC001",
      page: 1,
      page_size: 15,
    };

    fetch(`${process.env.REACT_APP_DCS}qa/sessions`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${s_token}`,
      },
      body: JSON.stringify(payload),
    }).then(async (res) => {
      let result = await res.json();
      if (result.data.length) {
        let filterDataWithSessionId = {};
        result.data.forEach((res) => {
          const date = new Date(
            res.qa_pairs[res.qa_pairs.length - 1].created_date
          ).toLocaleDateString();
          if (/^\d+$/.test(res.session_id)) {
            if (!filterDataWithSessionId[date]) {
              filterDataWithSessionId[date] = [res];
            } else {
              filterDataWithSessionId[date].push(res);
            }
          }
        });
        setChatHistory(filterDataWithSessionId);
        // let ee = Object.keys(filterDataWithSessionId)
        // console.log(filterDataWithSessionId[ee[0]],filterDataWithSessionId, "sdvihsdouvghsdudsvsdv")
      }
    });
  };

  const typeEffect = (text, callback) => {
    let index = 0;
    const delay = 10;

    const typeCharacter = () => {
      if (index < text.length) {
        callback(text.slice(0, index + 1));
        index++;
        setTimeout(typeCharacter, delay);
      } else {
        callback(text);
        setTextAnimationFinish(true);
      }
    };

    typeCharacter();
  };

  const handleInputChange = (e) => {
    setSampleMessage(e.target.value);
    setInput(e.target.value)
  };

  const getQuestionFromSpeechToText = (text) => {
    setSampleMessage(text);
    setInput(text);
  };
  const [showHeader, setShowHeader] = useState(true);

  console.log(base64pdf, "sfvdfbdf")

  const [currentServiceType, setCurrentServiceType] = useState("base");
  const [hasData, setHasData] = useState(false);

  const token = process.env.REACT_APP_KEY;



  const sendMessage = async (serviceType = "base", userPrompt = input) => {
    console.log(serviceType, userPrompt, "Sending Message...");

    setShowHeader(false);
    setInput("");

    if (loading) {
      setSnackbarmsg({
        msg: "Please wait till the previous response is loading.",
        type: "warning",
      });
      setOpenSnackbar(true);
      return;
    }

    if (!userPrompt) {
      setSnackbarmsg({ msg: "Please write a sample message", type: "warning" });
      setOpenSnackbar(true);
      return;
    }

    try {
      setLoading(true);

      setQaHistory((prevHistory) => [
        ...prevHistory,
        {
          question: userPrompt,
          answer: "Loading...",
          isLoading: true,
          serviceRecommendation: null,
        },
      ]);


      if (currentServiceType && serviceType === "base") {
        serviceType = currentServiceType;
      } else if (serviceType !== "base") {
        setCurrentServiceType(serviceType);
      }

      let apiUrl = `${process.env.REACT_APP_DCS}chatbot/llm_text_no_stream_v2`;
      let payload = {
        session_id: sessionId,
        patient_id: "CLINIC001",
        current_question: userPrompt,
        service_type: serviceType,
        subscription_status: hasData,
        lang: selectedLanguage
      };




      // if (base64pdf) {
      //   apiUrl = `${process.env.REACT_APP_DCS}chatbot/llm_with_attachment`;
      //   payload = {
      //     ...payload,
      //     file: base64pdf,
      //     file_url: "",
      //     mimetype: documanttype,
      //   };


      // }

      if (base64pdf) {
        apiUrl = `${process.env.REACT_APP_DCS}chatbot/llm_with_attachment`;
        payload = {
          ...payload,
          file: base64pdf,
          file_url: "",
          mimetype: documanttype,
          lang: selectedLanguage
        };


        const uploadPdfUrl = `${process.env.REACT_APP_DCS}upload_pdf/upload-pdf/`;
        const uploadPdfPayload = {

          base64_pdf: base64pdf,

        };

        try {
          const uploadResponse = await fetch(uploadPdfUrl, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(uploadPdfPayload),
          });

          if (!uploadResponse.ok) {
            console.error(`Failed PDF Upload: ${uploadResponse.status}`);
          } else {
            const uploadData = await uploadResponse.json();
            console.log("PDF Uploaded Successfully:", uploadData);
          }
        } catch (uploadError) {
          console.error("Error uploading PDF:", uploadError);
        }
      }






      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();
      const answer = data?.data?.answer || "No response received.";
      const recommendation = data?.data?.service_recommendation || null;
      const crmFlag = data?.data?.CRM_flag?.toString().toLowerCase() === "true";

      // Update conversation history
      setQaHistory((prevHistory) =>
        prevHistory.map((item, index) =>
          index === prevHistory.length - 1
            ? { ...item, answer, isLoading: false, serviceRecommendation: recommendation }
            : item
        )
      );
      setBase64pdf("");
      setUploadedFileName("");
      setTextAnimationFinish(false);
      typeEffect(answer, (typedText) => {
        updateAnswer(typedText);
      });

      setgetAnswerBot((prevAnswers) => [...prevAnswers, { response: answer }]);
      scrollToBottom();

      // Handle CRM flag
      if (crmFlag) {
        console.log("CRM flag is true. Resetting service type to base.");
        setCurrentServiceType("base");
        setUseDigitalPrescription(false);
        setchartEnded(true)
      } else {
        setCurrentServiceType(serviceType);
      }
    } catch (error) {
      console.error("Failed to fetch data:", error);
    } finally {
      setLoading(false);
      setSampleMessage("");
    }
  };

  console.log(qaHistory, getAnswerBot, "rftgh")



  const updateAnswer = (typedText) => {
    setQaHistory((prevHistory) =>
      prevHistory.map((item, index) =>
        index === prevHistory.length - 1 ? { ...item, answer: typedText } : item
      )
    );
  };

  const stripHtmlTags = (htmlString) => {
    const tempElement = document.createElement("div");
    tempElement.innerHTML = htmlString;

    const plainText = tempElement.textContent || tempElement.innerText || "";
    return plainText.replace(/\*/g, "");
  };

  useEffect(() => {
    return () => {
      Object.values(audioInstances).forEach((audio) => {
        audio.pause();
        audio.currentTime = 0;
      });
    };
  }, [audioInstances]);

  const handleSpeak = async (answer, index) => {
    try {
      const plainText = stripHtmlTags(answer).trim();

      if (!plainText) {
        messageApi.open({
          type: "warning",
          content: "No content to speak.",
        });
        return;
      }

      // Pause current audio if same index is clicked again
      if (playingAudioId === index && audioInstances[index]) {
        audioInstances[index].pause();
        audioInstances[index].currentTime = 0;
        setPlayingAudioId(null);
        return;
      }

      // Pause any other playing audio
      if (playingAudioId !== null && audioInstances[playingAudioId]) {
        audioInstances[playingAudioId].pause();
        audioInstances[playingAudioId].currentTime = 0;
      }

      // Detect language from the plain text
      const detectedLanguage = detectMajorLanguage(plainText);
      const speaker =
        detectedLanguage === "hi"
          ? "hi_male"
          : detectedLanguage === "or"
            ? "or_male"
            : "en_male";

      const requestBody = {
        text: [plainText],
        speaker,
        speed: 1,
        pitch: 0,
      };

      const response = await fetch(
        `${process.env.REACT_APP_CARESAATHIURL}translation/text-to-speech`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestBody),
        }
      );

      if (!response.ok) {
        throw new Error(`Failed request: ${response.statusText}`);
      }

      const data = await response.json();
      const audioBase64 = data?.audio_base64;

      if (!audioBase64) {
        throw new Error("No audio returned from server.");
      }

      const audioBlob = base64ToBlob(audioBase64, "audio/wav");
      const audioUrl = URL.createObjectURL(audioBlob);
      const audio = new Audio(audioUrl);

      setAudioInstances((prev) => ({
        ...prev,
        [index]: audio,
      }));

      audio.play();
      setPlayingAudioId(index);

      audio.onended = () => {
        setPlayingAudioId(null);
      };
    } catch (error) {
      console.error("Text-to-speech error:", error);
      messageApi.open({
        type: "error",
        content: error.message || "Something went wrong while playing audio.",
      });
    }
  };


  // Helper function to convert base64 to Blob
  const base64ToBlob = (base64, mimeType) => {
    const byteCharacters = atob(base64);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += 512) {
      const slice = byteCharacters.slice(offset, offset + 512);
      const byteNumbers = new Array(slice.length);

      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    return new Blob(byteArrays, { type: mimeType });
  };

  const handleFileChange = async (event) => {
    if (event.target.files.length > 0) {
      const selectedFile = event.target.files[0];

      // Function to convert file to base64
      const convertToBase64 = (file) => {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result);
          reader.onerror = reject;
          reader.readAsDataURL(file);
        });
      };

      const fileType = selectedFile.type;
      // const documentType = fileType.split("/")[1];
      // const validFileTypes = ["application/pdf", "image/jpeg", "image/png"];

      // if (!validFileTypes.includes(fileType)) {
      //   console.error("Unsupported file type.");
      //   // setOpenSnackbar(true);
      //   // setSnackbarmsg("Please upload a PDF or image file.");
      //   return;
      // }

      console.log(fileType, "selectedFile");
      setDocumanttype(fileType);
      const base64 = await convertToBase64(selectedFile);
      const base64Content = base64.split(",")[1];
      setBase64pdf(base64Content);
      console.log(base64Content, "base64 Content");
      setUploadedFileName(selectedFile.name);
      const formData = new FormData();
      formData.append("file", selectedFile, selectedFile.name);
      setopenLabReportAnalyserModal(false);
      // setSampleMessage("Analyse this Report");
      // Perform any further actions with the base64 data here
    }
  };

  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };

  const formatAnswer = (response) => {
    return response
      .split("\n")
      .map((line) => {
        let result = "";
        let inBold = false;

        if (line.startsWith("* **")) {
          const parts = line.split("**");
          return `<li><strong>${parts[1]}</strong>${parts[2]}</li>`;
        }

        if (line.startsWith("    * **")) {
          line = "  • " + line.slice(2);
        }

        for (let i = 0; i < line.length; i++) {
          if (line[i] === "*" && line[i + 1] === "*") {
            if (inBold) {
              result += "</strong>";
              inBold = false;
            } else {
              result += "<strong>";
              inBold = true;
            }
            i++;
          } else {
            result += line[i];
          }
        }

        if (inBold) {
          result += "</strong>";
        }

        if (line.startsWith("• ")) {
          return `<li>${result}</li>`;
        } else {
          return `<p>${result}</p>`;
        }
      })
      .join("");
  };

  const handleChatHistoryQuestionClick = (sessionId, qaPairs) => {
    Object.values(audioInstances).forEach((audio) => {
      audio.pause();
      audio.currentTime = 0;
    });
    setPlayingAudioId(null);
    setShowHeader(false);
    let result = qaPairs
      .map((res) => {
        return {
          question: res.question,
          answer: res.answer,
          isLoading: false,
          created_date: res.created_date,
        };
      })
      .sort((a, b) => new Date(a.created_date) - new Date(b.created_date));

    setTimestamp(sessionId);
    setQaHistory(result);
    setChatHistoryDrawer(false);

    // Ensure chat scrolls to the bottom after chat history is loaded
    scrollToBottom();
  };

  const handleNewChatWindow = () => {
    setSessionId(genrateRandomTimestamp());
    setShowHeader(true);
    setchartEnded(false);
    setQaHistory([]);
    setChatHistoryDrawer(false);
    setNewchartflag(true)
    Object.values(audioInstances).forEach((audio) => {
      audio.pause();
      audio.currentTime = 0;
    });
    setCurrentServiceType("base");
    getChatHistory();
    setPlayingAudioId(null);
  };

  console.log(sessionId, "rftgyh")

  const chatHistoryUI = () => {
    return (
      <div className="h-full flex flex-col">
        {/* Header */}
        <div className="relative p-6 border-b border-slate-700/50">
          <div className="absolute inset-0 bg-gradient-to-r from-[#004276]/15 to-[#00BD7F]/15" />
          <div className="relative flex items-center justify-between">
            <div className="flex items-center space-x-3">
              <div className="p-2 rounded-xl bg-gradient-to-br from-[#004276]/30 to-[#00BD7F]/30 backdrop-blur-sm">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="text-[#00BD7F]"
                >
                  <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
                </svg>
              </div>
              <h2 className="text-xl font-bold bg-gradient-to-r from-white to-slate-300 bg-clip-text text-transparent">
                Chat History
              </h2>
            </div>

            <div className="flex items-center space-x-2">
              <button
                onClick={handleNewChatWindow}
                aria-label="New chat"
                className="group relative p-2.5 rounded-xl bg-gradient-to-br from-[#004276]/30 to-[#00BD7F]/30 hover:from-[#004276]/40 hover:to-[#00BD7F]/40 transition-all duration-300 backdrop-blur-sm border border-white/10 hover:border-white/20"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="text-white group-hover:rotate-90 transition-transform duration-300"
                >
                  <path d="M5 12h14" />
                  <path d="m12 5 7 7-7 7" />
                </svg>
                <div className="absolute inset-0 rounded-xl bg-gradient-to-r from-[#004276]/20 to-[#00BD7F]/20 opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
              </button>
            </div>
          </div>
        </div>

        {/* Chat History Content */}
        <div className="flex-1 overflow-y-auto p-4 space-y-6 scrollbar-thin scrollbar-thumb-slate-600 scrollbar-track-transparent">
          {Object.keys(chatHistory)?.map((date, index) => (
            <div key={index} className="group">
              {/* Date Header */}
              <div className="flex items-center space-x-3 mb-4">
                <div className="flex items-center space-x-2 px-3 py-1.5 rounded-full bg-slate-800/50 border border-slate-700/50">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="text-slate-400"
                  >
                    <path d="M8 2v4" />
                    <path d="M16 2v4" />
                    <rect width="18" height="18" x="3" y="4" rx="2" />
                    <path d="M3 10h18" />
                  </svg>
                  <span className="text-sm font-medium text-slate-300">{date}</span>
                </div>
                <div className="flex-1 h-px bg-gradient-to-r from-slate-700/50 to-transparent" />
              </div>

              {/* Chat Sessions */}
              <div className="space-y-2">
                {chatHistory[date].map((session, sessionIndex) => {
                  const isActive = session.session_id === timeStamp;
                  const question = session.qa_pairs[session.qa_pairs.length - 1].question;

                  return (
                    <button
                      key={sessionIndex}
                      onClick={() => handleChatHistoryQuestionClick(Number(session.session_id), session.qa_pairs)}
                      className={`group/item w-full text-left p-4 rounded-xl transition-all duration-300 border backdrop-blur-sm relative overflow-hidden ${isActive
                        ? 'bg-gradient-to-r from-[#004276]/25 to-[#00BD7F]/25 border-[#00BD7F]/40 shadow-lg shadow-[#00BD7F]/15'
                        : 'bg-slate-800/30 border-slate-700/30 hover:bg-slate-800/50 hover:border-slate-600/50'
                        }`}
                    >
                      {/* Active indicator */}
                      {isActive && (
                        <div className="absolute left-0 top-0 bottom-0 w-1 bg-gradient-to-b from-[#004276] to-[#00BD7F] rounded-r" />
                      )}

                      {/* Content */}
                      <div className="relative flex items-start space-x-3">
                        <div className={`flex-shrink-0 w-2 h-2 rounded-full mt-2 transition-colors duration-300 ${isActive ? 'bg-[#00BD7F]' : 'bg-slate-500 group-hover/item:bg-slate-400'
                          }`} />

                        <div className="flex-1 min-w-0">
                          <p className={`text-sm font-medium transition-colors duration-300 line-clamp-2 ${isActive ? 'text-white' : 'text-slate-300 group-hover/item:text-white'
                            }`}>
                            {question}
                          </p>

                          {isActive && (
                            <div className="flex items-center space-x-1 mt-2">
                              <div className="w-1.5 h-1.5 bg-[#00BD7F] rounded-full animate-pulse" />
                              <span className="text-xs text-[#00BD7F] font-medium">Active</span>
                            </div>
                          )}
                        </div>

                        <div className={`flex-shrink-0 opacity-0 group-hover/item:opacity-100 transition-opacity duration-200 ${isActive ? 'opacity-100' : ''
                          }`}>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className="text-slate-400"
                          >
                            <path d="M12 20h9" />
                            <path d="M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4Z" />
                          </svg>
                        </div>
                      </div>

                      {/* Hover effect */}
                      <div className="absolute inset-0 bg-gradient-to-r from-[#004276]/10 to-[#00BD7F]/10 opacity-0 group-hover/item:opacity-100 transition-opacity duration-300 rounded-xl" />
                    </button>
                  );
                })}
              </div>
            </div>
          ))}
        </div>

        {/* Footer */}
        <div className="p-4 border-t border-slate-700/50 bg-slate-900/50">
          <div className="text-center">
            <p className="text-xs text-slate-500">
              {Object.values(chatHistory).flat().length} conversations
            </p>
          </div>
        </div>
      </div>
    );
  };

  const generateItems = (arrayReference, type, text, language) => {
    console.log(language, "LanguageGenerateItems")
    switch (language) {
      case "en":
        return [
          {
            label: "Hindi",
            key: "hi",
            onClick: () =>
              onClickLanguageDropdown(arrayReference, type, text, "en", "hi"),
          },
          {
            label: "Odia",
            key: "or",
            onClick: () =>
              onClickLanguageDropdown(arrayReference, type, text, "en", "or"),
          },
        ];
      case "hi":
        return [
          {
            label: "English",
            key: "en",
            onClick: () =>
              onClickLanguageDropdown(arrayReference, type, text, "hi", "en"),
          },
          {
            label: "Odia",
            key: "or",
            onClick: () =>
              onClickLanguageDropdown(arrayReference, type, text, "hi", "or"),
          },
        ];
      case "or":
        return [
          {
            label: "English",
            key: "en",
            onClick: () =>
              onClickLanguageDropdown(
                arrayReference,
                type,
                text,
                language,
                "en"
              ),
          },
          {
            label: "Hindi",
            key: "hi",
            onClick: () =>
              onClickLanguageDropdown(arrayReference, type, text, language,
                "hi"),
          },
        ];
      default:
        return [];
    }
  };

  const getDropdownTrigger = () => {
    const isMobile = window.innerWidth <= 768;
    return isMobile ? ["click"] : ["hover"];
  };

  const countCharactersInRange = (text, start, end) => {
    return Array.from(text).filter(
      (char) => start <= char.charCodeAt(0) && char.charCodeAt(0) <= end
    ).length;
  };

  const detectMajorLanguage = (text) => {
    const totalChars = text.length;
    if (totalChars === 0) {
      return "Empty Text";
    }

    const englishCount = countCharactersInRange(text, 0x0000, 0x007f);
    const hindiCount = countCharactersInRange(text, 0x0900, 0x097f);
    const odiaCount = countCharactersInRange(text, 0x0b00, 0x0b7f);


    const englishProportion = englishCount / totalChars;
    const hindiProportion = hindiCount / totalChars;
    const odiaProportion = odiaCount / totalChars;


    const proportions = {
      en: englishProportion,
      hi: hindiProportion,
      or: odiaProportion,
    };

    return Object.keys(proportions).reduce((a, b) =>
      proportions[a] > proportions[b] ? a : b
    );
  };

  const onClickLanguageDropdown = async (
    arrayReference,
    type,
    text,
    src_language,
    tgt_language
  ) => {
    try {
      let cleanText = text.replace(/<\/?[^>]+(>|$)/g, "");

      const payload = {
        text: [cleanText],
        src_lang: src_language,
        tgt_lang: tgt_language,
      };

      const response = await fetch(
        `${process.env.REACT_APP_CARESAATHIURL}translation/translate`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
      );

      if (!response.ok) throw new Error("Translation request failed");

      const data = await response.json();
      const translatedText = data?.responseList?.[0]?.outString;

      if (!translatedText) throw new Error("No translated text returned");

      setConvertedText({
        index: arrayReference,
        type: type,
        text: translatedText,
      });

      setQaHistory((prevHistory) => {
        const updatedHistory = [...prevHistory];
        if (type === "question") {
          updatedHistory[arrayReference] = {
            ...updatedHistory[arrayReference],
            questionLanguage: tgt_language,
            question: translatedText,
          };
        } else if (type === "answer") {
          updatedHistory[arrayReference] = {
            ...updatedHistory[arrayReference],
            answerLanguage: tgt_language,
            answer: translatedText,
          };
        }
        return updatedHistory;
      });

      setDisabledTranslations((prevSet) =>
        new Set(prevSet).add(`${type}-${arrayReference}`)
      );
    } catch (error) {
      console.error("Translation Error:", error);
      messageApi.open({
        type: "error",
        content: error.message || "Something went wrong during translation",
      });
    }
  };


  const sendError = (message) => {
    messageApi.open({
      type: "error",
      content: message,
    });
  };

  const handleNavigateToLabSelection = () => {
    const query = new URLSearchParams({
      referrer: "care-sathi", // Example query parameter, you can add more as needed
    }).toString();

    navigate(`/mylabreports?${query}`);
  };

  const onLanguageClick = (language) => {
    setSelectedLanguage(language);
    setLanguageModalVisible(false);
  };

  const handleOpenPopup = () => {
    setopenLabReportAnalyserModal(true);
    setlabreportanalyse(true);
    return true;

  };

  const phoneNumber = "+918335000999";
  const handleCallUs = () => {

    if (navigator.userAgent.match(/iPhone|Android/i)) {
      window.location.href = `tel:${phoneNumber}`;
    } else {
      navigator.clipboard.writeText(phoneNumber)
        .then(() => {

          setSnackbarmsg({ msg: "Phone number copied to clipboard!", type: "success" });
          setOpenSnackbar(true);
        })
        .catch(() => {
          setSnackbarmsg({ msg: "Failed to copy the phone number. Try again", type: "warning" });
          setOpenSnackbar(true);
        });
    }
  };

  function convertToBulletPoints(text) {
    const lines = text.split('\n');
    let inList = false;
    const htmlLines = lines.map(line => {

      let processedLine = line.replace(/\*{2,3}([^*]+)\*{2,3}/g, '<strong>$1</strong>');

      if (processedLine.trim().startsWith('*')) {
        if (!inList) {
          inList = true;
          return `<ul><li>${processedLine.replace(/^\*\s*/, '')}</li>`;
        }
        return `<li>${processedLine.replace(/^\*\s*/, '')}</li>`;
      } else {
        if (inList) {
          inList = false;
          return `</ul><p>${processedLine}</p>`;
        }
        return `<p>${processedLine}</p>`;
      }
    });

    if (inList) htmlLines.push('</ul>');

    return htmlLines.join('');
  }

  console.log(selectedLanguage, "swetfgy")

  return (
    <>
      <OurLayouts hideSidebar={true}>

        {contextHolder}
        <Snackbar
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          open={openSnackbar}
          autoHideDuration={2500}
          onClose={handleCloseSnackbar}
        >
          <Alert
            onClose={handleCloseSnackbar}
            severity={snackbarmsg.type}
            variant="filled"
            sx={{ width: "100%" }}
          >
            {snackbarmsg.msg}
          </Alert>
        </Snackbar>

        <div className="flex flex-col justify-center items-center w-full min-h-0 max-sm:min-h-screen bg-white">
          {/* Web/Tablet Menu Icon */}
        {/* Desktop/Tablet Menu Icon (visible from `sm` and above) */}
        <MenuOutlined
    className="hidden sm:block pt-2 absolute top-24 left-2 z-20"
    onClick={() => {
      getChatHistory();
      setChatHistoryDrawer(true);
    }}
  />

  {/* ✅ Mobile Menu Icon (left side only for small screens) */}
  <MenuOutlined
    className="block sm:hidden absolute top-20 left-4 z-50 bg-white p-2 rounded-md shadow-md"
    onClick={() => {
      getChatHistory();
      setChatHistoryDrawer(true);
    }}
  />




          <div className="flex flex-col items-center w-full overflow-hidden relative px-2 sm:px-6 md:px-20 chat-container">
            <div className="flex flex-col items-center w-full justify-center z-10 ">
              {showHeader && (
                <div className="flex flex-col w-full">
                  {/* curebaylogo with header */}
                  <div className="flex flex-col justify-center items-center text-center w-full">
                    <div>
                      <img
                        src="https://www.curebay.com/static/media/caresathi_logo_ai.a373370db0fbf1da5fa825637fc2e133.svg"
                        alt="Care Sathi Logo"
                        className="h-14 w-14 sm:h-16 sm:w-16 md:h-20 md:w-20 mt-2 mx-auto"
                      />
                    </div>
                    <h1 className="text-lg sm:text-xl md:text-3xl text-[#005D8E] text-center font-bold pt-2 md:pt-3">
                      CareSathi
                    </h1>
                    <p className="text-center text-gray-600 text-xs sm:text-sm md:text-base mt-1 md:mt-2">
                      <span className="font-semibold">Care to Cure,</span>{" "}
                      <span className="font-normal">your journey starts here</span>
                    </p>
                  </div>
                  {/* select language */}
                  <div className="p-2 sm:p-4 text-center w-full">
                    <p className="mb-2 sm:mb-3 text-xs sm:text-sm">Select language:</p>
                    <div className="relative flex justify-center border-2 border-gray-300 rounded-full text-xs sm:text-sm md:text-base bg-gray-50 overflow-hidden shadow-lg w-full max-w-xs mx-auto">
                      {/* Animated background slider */}
                      <div
                        className="absolute top-0 h-full rounded-full transition-all duration-300 ease-in-out z-0"
                        style={{
                          width: '33.333%',
                          left: selectedLanguage === 'en' ? '0%' :
                            selectedLanguage === 'hi' ? '33.333%' : '66.666%',
                          background: 'linear-gradient(to right, #004276, #00BD7F)'
                        }}
                      />
                      {/* Buttons */}
                      <button
                        className={`relative z-10 px-2 sm:px-4 md:px-9 py-2 flex-1 rounded-full transition-colors duration-300 font-medium ${selectedLanguage === "en" ? "text-white" : "text-gray-800"}`}
                        onClick={() => setSelectedLanguage("en")}
                      >
                        English
                      </button>
                      <button
                        className={`relative z-10 px-2 sm:px-4 md:px-9 py-2 flex-1 rounded-full transition-colors duration-300 font-medium ${selectedLanguage === "hi" ? "text-white" : "text-gray-800"}`}
                        onClick={() => setSelectedLanguage("hi")}
                      >
                        Hindi
                      </button>
                      <button
                        className={`relative z-10 px-2 sm:px-4 md:px-9 py-2 flex-1 rounded-full transition-colors duration-300 font-medium ${selectedLanguage === "or" ? "text-white" : "text-gray-800"}`}
                        onClick={() => setSelectedLanguage("or")}
                      >
                        Odia
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </div>
            <MenuOutlined
              className="block sm:hidden pt-2 absolute top-2 right-2 z-20"
              onClick={() => setChatHistoryDrawer(true)}
            />
            <div
              className="flex flex-col justify-between mt-2 overflow-y-auto chat-container w-full"
              style={{
                scrollbarWidth: "none",
              }}
              ref={chatContainerRef}
            >
              {qaHistory.length ?

                (
                  qaHistory.map((item, index) => (
                    <div key={index} className="mb-8">
                      <div
                        className="p-2 float-right mb-2 mr-2 sm:mr-0"
                        style={{ backgroundColor: "#f4f4f4", borderRadius: "10px" }}
                      >
                        <div className="w-full flex justify-between">
                          <div className="flex">
                            <img
                              src="https://www.curebay.com/static/media/caresathi_logo_ai.a373370db0fbf1da5fa825637fc2e133.svg"
                              alt="Care Sathi Logo"
                              className="h-7 w-7 mt-1"
                            />
                            <p className="sm:pt-1 pl-3 pr-3" style={{ fontSize: 14 }}>
                              {convertedText.index == index &&
                                convertedText.type == "question"
                                ? convertedText.text
                                : item.question}
                            </p>
                          </div>

                          <Dropdown
                            overlay={
                              <Menu
                                items={generateItems(
                                  index,
                                  "question",
                                  item.question,
                                  selectedLanguage
                                )}
                              />
                            }
                            trigger={getDropdownTrigger()}

                          >
                            <Button
                            >
                              <TranslateIcon />
                            </Button>
                          </Dropdown>

                        </div>
                      </div>

                      <div className="flex bgclr px-2 sm:px-4 py-3 w-full gap-3">
                        <div className=" ">
                          {item.isLoading ? (
                            <ChatLoading />
                          ) : (
                            <div className="flex justify-start mb-4">
                              <div className="max-w-[90%] sm:max-w-[70%] bg-gradient-to-r from-[#5A7BA3] to-[#4DD4A8] text-white p-5 rounded-2xl shadow-lg shadow-[#5A7BA3]/25 border border-[#5A7BA3]/20 backdrop-blur-sm transition-all duration-300 hover:scale-[1.02]">
                                <div className="flex justify-between items-center mb-3">
                                  {textAnimationFinish && (
                                    <div className="flex space-x-2">
                                      <Dropdown
                                        overlay={
                                          <Menu
                                            items={generateItems(index, "answer", item.answer, selectedLanguage)}
                                          />
                                        }
                                        disabled={disabledTranslations.has(`answer-${index}`)}
                                        trigger={getDropdownTrigger()}
                                      >
                                        <Button
                                          icon={<TranslateIcon />}
                                          className="bg-white/15 hover:bg-white/25 border-white/25 text-white backdrop-blur-sm hover:scale-105 transition-all duration-200"
                                        />
                                      </Dropdown>
                                      <Button
                                        icon={playingAudioId === index ? <PauseIcon /> : <VolumeUpIcon />}
                                        onClick={() => handleSpeak(item.answer, index)}
                                        className="bg-white/15 hover:bg-white/25 border-white/25 text-white backdrop-blur-sm hover:scale-105 transition-all duration-200 font-medium"
                                      >
                                        {playingAudioId === index ? "Pause" : "Play"}
                                      </Button>
                                    </div>
                                  )}
                                </div>
                                <div
                                  className="text-sm leading-relaxed"
                                  dangerouslySetInnerHTML={{
                                    __html:
                                      convertedText.index === index &&
                                        convertedText.type === "answer"
                                        ? convertToBulletPoints(convertedText.text)
                                        : convertToBulletPoints(item.answer),
                                  }}
                                />
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  ))
                )


                : (
                  <div className="flex flex-col">
                    {newchartflag === true && !showHeader &&
                      <div className="flex flex-col justify-center  items-center text-center">
                        <div>
                          <img
                            src="https://www.curebay.com/static/media/caresathi_logo_ai.a373370db0fbf1da5fa825637fc2e133.svg"
                            alt="Care Sathi Logo"
                            className="h-16 w-16 sm:h-20 sm:w-20 mt-2"
                          />
                        </div>
                        {/* <div className="flex flex-col"> */}
                        <h1 className="text-xl sm:text-3xl text-[#005D8E] text-center sm:text-left font-bold pt-3">
                          CareSathi
                        </h1>
                        <p className="text-center sm:text-left text-gray-600 text-sm sm:text-base mt-2">
                          <span className="font-semibold">Care to Cure,</span>{" "}
                          <span className="font-normal">your journey starts here</span>
                        </p>
                      </div>

                    }


                    <div className="flex flex-col justify-center sm:flex-row gap-6 p-4 ">
                      {/* Card 1 */}
                      <button
                        onClick={() =>
                          setInput(
                            selectedLanguage == "en"
                              ? "What are diabetes symptoms?"
                              : selectedLanguage == "hi"
                                ? " डायबिटीज के लक्षण क्या हैं?"
                                : selectedLanguage == "or"
                                  ? "ଡାଇବେଟିସର ଲକ୍ଷଣଗୁଡ଼ିକ କ'ଣ?"
                                  : ""
                          )
                        }
                        className="h-max ai-suggestion-card flex flex-col  p-4 bg-White rounded-lg shadow-md hover:shadow-lg transition-shadow border border-lightGray h-40"
                      >
                        <p
                          className="text-center text-gray-600 break-word"
                          style={{ color: "#676767" }}
                        >
                          {selectedLanguage == "en"
                            ? "What are diabetes symptoms?"
                            : selectedLanguage == "hi"
                              ? " डायबिटीज के लक्षण क्या हैं?"
                              : selectedLanguage == "or"
                                ? "ଡାଇବେଟିସର ଲକ୍ଷଣଗୁଡ଼ିକ କ'ଣ?"
                                : ""}{" "}
                        </p>
                      </button>

                      {/* Card 2 */}
                      <button
                        onClick={() =>
                          setInput(
                            selectedLanguage == "en"
                              ? "How to manage high BP?"
                              : selectedLanguage == "hi"
                                ? "उच्च रक्तचाप को कैसे नियंत्रित करें?"
                                : selectedLanguage == "or"
                                  ? "ଉଚ୍ଚ ରକ୍ତଚାପ କେମିତି ପରିଚାଳନା କରିବେ?"
                                  : ""
                          )
                        }
                        className="h-max ai-suggestion-card flex flex-col  p-4 bg-White rounded-lg shadow-md w-full sm:w-[250px] hover:shadow-lg transition-shadow border border-lightGray  "
                      >
                        <p
                          className="text-center text-gray-600 break-word"
                          style={{ color: "#676767" }}
                        >
                          {selectedLanguage == "en"
                            ? "How to manage high BP?"
                            : selectedLanguage == "hi"
                              ? "उच्च रक्तचाप को कैसे नियंत्रित करें?"
                              : selectedLanguage == "or"
                                ? "ଉଚ୍ଚ ରକ୍ତଚାପ କେମିତି ପରିଚାଳନା କରିବେ?"
                                : ""}{" "}
                        </p>
                      </button>

                      {/* Card 3 */}
                      <button
                        onClick={() =>
                          setInput(
                            selectedLanguage == "en"
                              ? "Exercises for back pain?"
                              : selectedLanguage == "hi"
                                ? "पीठ दर्द के लिए कौन से व्यायाम करें?"
                                : selectedLanguage == "or"
                                  ? "ପିଠିର ବେଥା ପାଇଁ କେଉଁସବୁ ଅଭ୍ୟାସ କରିବେ?"
                                  : ""
                          )
                        }
                        className="h-max ai-suggestion-card flex flex-col  p-4 bg-White rounded-lg shadow-md w-full sm:w-[250px] hover:shadow-lg transition-shadow border border-lightGray  sm:mb-0"
                      >
                        <p
                          className="text-center text-gray-600 break-word"
                          style={{ color: "#676767" }}
                        >
                          {selectedLanguage == "en"
                            ? "Exercises for back pain?"
                            : selectedLanguage == "hi"
                              ? "पीठ दर्द के लिए कौन से व्यायाम करें?"
                              : selectedLanguage == "or"
                                ? "ପିଠିର ବେଥା ପାଇଁ କେଉଁସବୁ ଅଭ୍ୟାସ କରିବେ?"
                                : ""}{" "}
                        </p>
                      </button>
                    </div>
                  </div>
                )}
              {/* </div> */}
            </div>


            <div
              className=" w-full sm:w-[70%] mx-auto boxposition fixed bottom-0 px-2 sm:px-20"
              style={{
                paddingBottom: 5,
                backgroundColor: "white",
              }}
            >
              <div className="pt-2">
                {uploadedFileName && (
                  <span
                    className="text-sm font-normal mb-2 ml-7 py-2 px-2 shadow rounded"
                    style={{ backgroundColor: "#ffff" }}
                  >
                    <strong>Uploaded File:</strong> {uploadedFileName}
                  </span>
                )}
                {chartEnded ?
                  <>
                    <div className="flex justify-center text-center text-sm sm:text-lg">
                      <p>Your chat has ended. &nbsp;</p>
                      <button
                        onClick={handleNewChatWindow}
                        className="text-primaryColor underline hover:text-[#050a30] transition-all"
                      >
                        Start a new conversation
                      </button>
                    </div>


                  </> :
                  <>
                    <div className="w-full flex justify-between relative items-center pb-3">
                      <label
                        className="flex text-lg font-normal p-3 cursor-pointer absolute"
                        onClick={handleOpenPopup}
                      >
                        <img src={AttachFileIcon} alt="Attach File" className="w-6" />

                      </label>

                      <InputText
                        value={input || sampleMessage}
                        // onChange={(e) => setInput(e.target.value)}
                        onChange={handleInputChange}
                        onKeyUp={(e) => {
                          if (e.key === "Enter" && !e.shiftKey) {
                            e.preventDefault();
                            sendMessage()

                            // handleArrowClick(e);
                          }
                        }}
                        placeholder={
                          selectedLanguage == "en"
                            ? "Type your Medical Problems only ..."
                            : selectedLanguage == "hi"
                              ? "केवल अपनी चिकित्सा समस्याएं टाइप करें।"
                              : selectedLanguage == "or"
                                ? "କେବଳ ଆପଣଙ୍କ ଚିକିତ୍ସା ସମସ୍ୟାଗୁଡ଼ିକ ଲେଖନ କରନ୍ତୁ।"
                                : ""
                        }
                        lang={selectedLanguage}
                        style={{
                          maxHeight: "200px",
                          height: "52px",
                          width: "100%",
                          border: "none",
                          backgroundColor: "#f4f4f4",
                          outline: "none",

                        }}

                        className={` pr-20 pl-4 sm:text-base  text-sm p-inputtext p-component p-filled sm:pl-12 ${lab_report_analyser === "true" ? "pl-[35px]" : "pl-[40px]"
                          }`}
                      />

                      <div className="absolute right-2 sm:right-4 flex">
                        <MicRecorder
                          getQuestionFromSpeechToText={getQuestionFromSpeechToText}
                          sendError={sendError}
                          selectedLanguage={selectedLanguage}
                        />
                        {/* {labreportanalyseflag === false ? */}
                        {/* <button
                        onClick={() =>
                        (
                          sendMessage())}
                      >
                        <img src={Send} alt="#" />
                      </button> */}

                        <button
                          onClick={() =>
                          (
                            sendMessage())}
                          className="px-3 py-2 bg-gradient-to-r from-[#004276] to-[#00BD7F] text-white rounded-lg hover:from-[#003666] hover:to-[#00A86B] transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed shadow-sm"
                        >
                          <Send className="w-4 h-4" />
                        </button>



                        {/* : labreportanalyseflag === true ?
                      <button
                        onClick={() =>
                        (
                          handleArrowClick())}
                      >
                        <img src={Send} alt="#" />
                      </button> : ""
                  } */}

                      </div>
                    </div>
                  </>}

                {/* <p class="flex text-lg font-normal pr-3">Disclaimer</p> */}
              </div>
            </div>

          </div>
        </div>

        <Drawer
          styles={{
            body: {
              padding: 0,
              overflow: "hidden",
            },
            header: {
              display: 'none', // This hides the entire header
            }
          }}
          // title="Chat History" // Remove this line
          onClose={() => setChatHistoryDrawer(false)}
          placement="left"
          open={chatHistoryDrawer}
          closable={false} // Remove default close button since header is hidden
        >
          <div
            style={{
              height: "100vh", // Full height
              overflow: "hidden", // Prevent extra scroll
              background: "linear-gradient(135deg, #1e293b 0%, #334155 50%, #1e293b 100%)",
              position: "relative",
            }}
          >
            <div style={{ position: "absolute", inset: 0, pointerEvents: "none", background: "linear-gradient(to right, rgba(0, 66, 118, 0.1), rgba(0, 189, 127, 0.1))" }} />
            <div style={{ position: "relative", height: "100%", overflowY: "auto" }}>
              {chatHistoryUI()}
            </div>
          </div>
        </Drawer>


        <Modal
          title="Disclaimer"
          className="commonModal"
          open={false}
          onOk={() => setshowaddmemberpopup(!showaddmemberpopup)}
          onCancel={() => {
            setshowaddmemberpopup(!showaddmemberpopup);
          }}
          width="65%"
          style={{ top: 20 }}
          footer={[]}
        >
          <p className="sm:text-base text-sm">
            {" "}
            CareSathi AI is designed to provide an automatic response with a
            general overview of the user's health status based on the available
            research data. CareSathi AI is not tailored to detect individual
            symptoms and is not a substitute for professional medical diagnosis.
            Users bear sole responsibility for their reliance on the response and
            we expressly disclaim any and all liability arising from the use and
            reliance on CareSathi AI responses. For personalized advice and
            recommendations, pls visit our CureBay clinic.
          </p>
        </Modal>

        <Modal
          open={openLabReportAnalyserModal}
          onOk={() => { }}
          onCancel={() => setopenLabReportAnalyserModal(false)}
          footer={null} // Remove the default footer
          centered // Center the modal
          width={400} // Adjust width to match your design
          bodyStyle={{ padding: "30px", textAlign: "center" }} // Custom body styles
        >
          {/* Modal Content */}
          <Title level={4}>Share your report here</Title>
          <Text
            type="secondary"
            style={{ display: "block", marginBottom: "20px" }}
          >
            You can upload the report from your device or select it from the Lab
            Reports section.
          </Text>

          {/* Buttons */}
          <Button
            onClick={() => fileInputRef.current.click()}
            icon={<UploadOutlined />}
            style={{
              width: "100%",
              marginBottom: "15px",
              backgroundColor: "#004171",
              color: "#ffff",
            }}
          >
            <input
              type="file"
              style={{ display: "none" }}
              onChange={handleFileChange}
              ref={fileInputRef}
            />
            Upload Your Report
          </Button>
          {/* <Button
            type="default"
            onClick={handleNavigateToLabSelection}
            icon={<SearchOutlined />}
            style={{ width: "100%", borderColor: "#004171", color: "#004171" }}
          >
            Find Your Lab Report
          </Button> */}
        </Modal>
      </OurLayouts>
    </>
  );
};

export default Newcaresathi;